/**
 * WachtrijMislukt — handelingen die het toestel niet kon versturen en die de
 * server weigerde of die te lang bleven liggen (lib/sync/wasserij-wachtrij.ts).
 * Het kleed staat dan nog in de oude status; de medewerker moet de handeling
 * opnieuw doen. Tot 03-11 verdwenen zulke saves zonder spoor (#144/#159).
 */

import { useLiveQuery } from 'dexie-react-hooks';
import { WbButton, WbFlag } from './wb';
import { leesMislukt, wisMislukt } from '../lib/sync/wasserij-wachtrij';

export function WachtrijMislukt({ soort }: { soort: 'voorinspectie' | 'reinigen' | 'na-inspectie' }) {
  // liveQuery volgt de tabellen die leesMislukt leest: de vlag loopt mee met de wachtrij.
  const rijen = useLiveQuery(async () => (await leesMislukt()).filter((r) => r.soort === soort), [soort], []);
  if (!rijen || rijen.length === 0) return null;
  return (
    <WbFlag kind="geld" title={`${rijen.length} ${soort} niet opgeslagen`}>
      <p>Doe deze opnieuw; het kleed staat nog in de oude status.</p>
      <ul className="mt-1 space-y-1">
        {rijen.map((r) => (
          <li key={`${r.soort}-${r.id}`} className="flex items-center justify-between gap-2">
            <span>
              <span className="font-mono font-semibold">{r.itemName ?? 'Kleed'}</span>: {r.fout}
            </span>
            <WbButton variant="link" fullWidth={false} onClick={() => void wisMislukt(r)}>
              Gezien
            </WbButton>
          </li>
        ))}
      </ul>
    </WbFlag>
  );
}
